/**
 * Revenues tab split by business line (Fan, 2026-10-27): "Property
 * Portfolio" and "BR OS" (Bonjour Residences OS).
 *
 * Built from the same entity P&L months and the same row function as the
 * Profit & Loss tab (lib/entityPnlRows.js), so the split always adds up to
 * the P&L tab's revenue total:
 *   BR OS              = invoiced BR OS revenue (revenue_actual)
 *   Property Portfolio = gross booking revenue (gross_revenue_actual)
 * Year to date: months up to and including the current month.
 */
import { entityPnlYtdRows, sumRows, pnlSources } from './entityPnlRows';

export const BUSINESS_LINES = [
  { key: 'portfolio', label: 'Property Portfolio', color: '#3B82F6' },
  { key: 'bros', label: 'BR OS', color: '#8B5CF6' },
];

export function businessLineSplit(entityPnl, year, now) {
  if (!entityPnl || !Array.isArray(entityPnl.months)) return null;
  var srcs = pnlSources(entityPnl.months);
  var rows = entityPnlYtdRows(entityPnl.months, year, now).map(function (r) {
    return {
      month: r.month,
      label: r.label,
      portfolio: r.portfolio_revenue,
      bros: r.bros_revenue,
      total: r.revenue,
    };
  });
  var tot = sumRows(entityPnlYtdRows(entityPnl.months, year, now));
  return {
    currency: entityPnl.currency || 'GBP',
    hasPortfolio: srcs.portfolio,
    hasBros: srcs.bros,
    // The split is only worth showing when both lines exist.
    showSplit: srcs.portfolio && srcs.bros,
    lines: BUSINESS_LINES.filter(function (l) {
      return l.key === 'portfolio' ? srcs.portfolio : srcs.bros;
    }),
    rows: rows,
    totals: { portfolio: tot.portfolio_revenue, bros: tot.bros_revenue, total: tot.revenue },
  };
}
